(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["markiewka-bestsellers"] && !Shopify.designMode) return;
  try {
    
function initializeMarkiewkaBestsellers() {
  document.querySelectorAll('[data-mk-bestsellers]').forEach(function(section) {
    if (section.dataset.mkReady) return;
    section.dataset.mkReady = 'true';
    const track = section.querySelector('.mk-best-track');
    section.addEventListener('click', function(event) {
      const previous = event.target.closest('[data-mk-best-prev]');
      const next = event.target.closest('[data-mk-best-next]');
      if (previous || next) {
        track.scrollBy({left:(previous ? -1 : 1)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMarkiewkaBestsellers);
else initializeMarkiewkaBestsellers();
document.addEventListener('shopify:section:load', initializeMarkiewkaBestsellers);

  } catch(e) { console.error(e); }
})();
})();
